import { Card, Icon } from 'ui/components/primitives';
import { ProgressBar, ToolTip } from 'ui/components/compounds';
import { Progress } from './Progress.styles';
import type { CartProgressProps } from './Progress.d';

const CartProgress = ({ maxValue, remainingValue, value }: CartProgressProps) => {
  const isCompleted = value >= maxValue;

  return (
    <Progress.Component data-testid="cart-progress">
      <Card radius="rounded" spacing="medium">
        {isCompleted ? (
          <Progress.Info>Você atingiu o valor do pedido mínimo</Progress.Info>
        ) : (
          <Progress.Info>
            {remainingValue}
            <ToolTip
              align="right"
              content="O valor do pedido mínimo é calculado de acordo com o valor a pagar, ele considera algumas variáveis que podem sofrer alterações na finalização do pagamento. Devido a descontos de promoções."
              direction="down"
              withIcon
            >
              <Icon.Info size="s" />
            </ToolTip>
          </Progress.Info>
        )}

        <ProgressBar color="primary" maxValue={maxValue} value={value} />
      </Card>
    </Progress.Component>
  );
};

export default CartProgress;
